import { useMutation, useQueryClient } from '@tanstack/react-query';
import { refundPayment } from '@/services/subscription.service';
import { queryKeys } from '@/hooks/queries/keys';
import type { SubscriptionPaymentDto } from '@/types/subscription';

export const useRefundPayment = () => {
    const queryClient = useQueryClient();
    return useMutation<SubscriptionPaymentDto, unknown, string>({
        mutationFn: refundPayment,
        onSuccess: (_data, id) => {
            queryClient.invalidateQueries({ queryKey: queryKeys.subscription.payments() });
            queryClient.invalidateQueries({ queryKey: queryKeys.subscription.payment(id) });
            queryClient.invalidateQueries({ queryKey: queryKeys.subscription.me() });
        },
    });
};
